import { TableViewerComponent } from './components/Table';

import chargerIcon from '../../../assets/charger-icon.png';
import energyIcon from '../../../assets/energy-icon.svg';
import timeIcon from '../../../assets/time-icon.png';
import checkIcon from '../../../assets/check-icon.png';
import moment from 'moment';
import { getConnectorStatusStyle } from './configs/utils';

export const ChargerStatusPage = ({ data }: any) => {
  return (
    <TableViewerComponent
      data={data}
      columns={[
        {
          name: 'vehicle',
          label: 'Carregador',
          align: 'left',
          icon: chargerIcon,
          render: (connector: any) => {
            return (
              <div className='vp-charger-info'>
                <span className='vp-charger-name'>{connector.name}</span>
                <span className='vp-cp-code'>
                  {connector.uvName
                    ? `${connector.uvName} (${connector.soC?.toFixed(0)} %)`
                    : `${connector.cpCode}-${connector.connectorId}`}
                </span>
              </div>
            );
          },
        },
        {
          name: 'autonomy',
          label: 'Energia',
          align: 'center',
          icon: energyIcon,
          render: (connector: any) => {
            return connector.transactionId ? (
              <div className='vp-power-info' style={{ whiteSpace: 'nowrap' }}>
                <span style={{ whiteSpace: 'nowrap' }} className='vp-power-kWh'>
                  {connector.meterKWH?.toFixed(1)} kWh
                </span>
                <span style={{ whiteSpace: 'nowrap' }} className='vp-power-kW'>
                  {connector.chargeRateKW.toFixed(1)} kW
                </span>
              </div>
            ) : (
              '-'
            );
          },
        },
        {
          name: 'duration',
          label: 'Duração',
          align: 'center',
          icon: timeIcon,
          render: (connector: any) => {
            const duration = connector.requiredChargeTime;
            const formattedDuration = duration ? duration.substring(0, 5) : '-';
            const brazilianTime = moment(connector.startTime)
              .utcOffset(-3)
              .format('HH:mm');
            return connector.transactionId ? (
              <div className='vp-duration-info'>
                <span
                  className='vp-charge-duration'
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {formattedDuration}
                </span>
                <span
                  className='vp-charging-time'
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {brazilianTime}
                </span>
              </div>
            ) : (
              '-'
            );
          },
        },
        {
          name: 'plate',
          label: 'Status',
          align: 'center',
          icon: checkIcon,
          render: (connector: any) => {
            const { text, bg, color } = getConnectorStatusStyle(connector);
            return (
              <div className='vp-charger-status-container'>
                <div
                  className='vp-chager-status-wrapper'
                  style={{ backgroundColor: bg }}
                >
                  <span
                    className='vp-charger-status-span'
                    style={{ color: color }}
                  >
                    {text}
                  </span>
                </div>
              </div>
            );
          },
        },
      ]}
    />
  );
};
